import React, { FC } from 'react';
import styled from 'styled-components';

const Container = styled.div<{ $isWarning?: boolean }>`
    display: block;
    color: #445a64;
    cursor: default;
    font-weight: normal;
    border: 1px solid ${(props) => (props.$isWarning ? '#e65100' : '#de1c22')};
    border-radius: 6px;
    padding: 8px 10px;
    background-color: ${(props) => (props.$isWarning ? '#fff3e0' : '#fff5f5')};
    font-size: 13px;
    line-height: 1.5;

    a {
        color: ${(props) => props.theme.app.component.link.color};
        text-decoration: underline;
        cursor: pointer;
    }
`;

export const ErrorCalloutTitle = styled.span<{ $isWarning?: boolean }>`
    color: ${(props) => (props.$isWarning ? '#e65100' : '#de1c22')};
    font-weight: bold;
    display: block;
    margin-bottom: 8px;
`;

interface ErrorCalloutProps {
    title?: React.ReactNode;
    children: React.ReactNode;
    isWarning?: boolean;
    className?: string;
}

export const ErrorCallout: FC<ErrorCalloutProps> = ({ title, children, isWarning, className }) => {
    return (
        <Container $isWarning={isWarning} className={className}>
            {title && <ErrorCalloutTitle $isWarning={isWarning}>{title}</ErrorCalloutTitle>}
            {children}
        </Container>
    );
};
